import script from "./BaseConnectCrmDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseConnectCrmDialog.vue?vue&type=script&setup=true&lang=js"

import "./BaseConnectCrmDialog.vue?vue&type=style&index=0&id=12b07006&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12b07006"]])

export default __exports__